import { SizeUnit }                                             from '@cs/core';
import { DataEntryStateDataDescribedLayoutMappingStickyHeader } from '../data-entry-state-data-described.converter';
import { DataEntryStateColumnType }                             from '../models/data-entry-state-column';

export class DataEntryVisualState {
	headerType?: 'horizontal' | 'vertical'  = 'horizontal';
	alignment?: 'center' | 'left' | 'right' = 'left';
	placeholder?: boolean;
	visible?: boolean;
	cellTemplate?: DataEntryStateColumnType;
	isFirst?: boolean;
	/**
	 * Width provided by the server
	 */
	width?: SizeUnit<number, string>;
	sticky?: boolean;
}
